import { render, staticRenderFns } from "./CabinetRowCard.vue?vue&type=template&id=408d94ec&scoped=true&"
import script from "./CabinetRowCard.vue?vue&type=script&lang=ts&"
export * from "./CabinetRowCard.vue?vue&type=script&lang=ts&"
import style0 from "./CabinetRowCard.vue?vue&type=style&index=0&id=408d94ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d94ec",
  null
  
)

export default component.exports